/**
 * UNDRGRND native preview player (single global <audio>, Spotify-style bar).
 */
(function () {
  'use strict';

  var PLAYER_ID = 'ug-audio-player';
  var AUDIO_ID = 'ug-audio-element';
  var CONTEXT_SEL = '[data-ug-audio-page-context]';
  var VOLUME_STORAGE_KEY = 'ug-audio-player-volume';

  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '0:00';
    var m = Math.floor(seconds / 60);
    var s = Math.floor(seconds % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function parsePlaylistFromButton(btn) {
    if (btn.getAttribute('data-ug-audio-scope') === 'single') {
      return [btn];
    }
    /* Catalogue / related cards: one preview per tile, not the host PDP playlist. */
    if (btn.classList.contains('ug-audio-play-trigger--card')) {
      return [btn];
    }
    var ctx = btn.closest(CONTEXT_SEL);
    if (ctx) {
      var demosHost = ctx.querySelector('[data-ug-product-demos]');
      if (demosHost) {
        var playlist = [];
        var hero = ctx.querySelector('.ug-audio-play-trigger--hero');
        if (hero && (hero.getAttribute('data-ug-audio-src') || '').trim()) {
          playlist.push(hero);
        }
        Array.prototype.slice
          .call(demosHost.querySelectorAll('.ug-audio-play-trigger[data-ug-audio-src]'))
          .sort(function (a, b) {
            var ai = parseInt(a.getAttribute('data-ug-demo-index') || '0', 10);
            var bi = parseInt(b.getAttribute('data-ug-demo-index') || '0', 10);
            return ai - bi;
          })
          .forEach(function (trackBtn) {
            if (playlist.indexOf(trackBtn) < 0) playlist.push(trackBtn);
          });
        if (playlist.length) return playlist;
      }
    }
    var bundleVisual = btn.closest('.ug-bundle-hero__visual');
    if (bundleVisual) {
      var bundleDemos = bundleVisual.querySelector('[data-ug-bundle-demos]');
      var bundleList =
        bundleDemos && bundleDemos.querySelector('[data-ug-bundle-demos-list]');
      if (bundleList) {
        var bundlePlaylist = Array.prototype.slice.call(
          bundleList.querySelectorAll(
            '.ug-audio-play-trigger[data-ug-audio-src], .ug-audio-play-trigger[data-ug-sc-progressive]'
          )
        );
        if (bundlePlaylist.length) return bundlePlaylist;
      }
    }
    var grid = btn.closest('.product-grid');
    var scope = grid || btn.closest(CONTEXT_SEL) || document.body;
    return Array.prototype.slice.call(
      scope.querySelectorAll('.ug-audio-play-trigger[data-ug-audio-title]')
    );
  }

  function readTrack(btn) {
    return {
      title: btn.getAttribute('data-ug-audio-title') || '',
      image: btn.getAttribute('data-ug-audio-image') || '',
      src: btn.getAttribute('data-ug-audio-src') || '',
      productUrl: btn.getAttribute('data-ug-audio-product-url') || '#',
      variantId: btn.getAttribute('data-ug-audio-variant-id') || ''
    };
  }

  function handleFromProductUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function getBundleHeroBtnForPlaylist(playlist) {
    if (!playlist.length) return null;
    var visual = playlist[0].closest('.ug-bundle-hero__visual');
    if (!visual) return null;
    return visual.querySelector('.ug-audio-play-trigger--hero');
  }

  /** Bundle 3 hero list: player art/link use bundle PDP, not each pack. */
  function getBundle3PlayerDisplay(btn) {
    var host = btn && btn.closest('[data-ug-bundle-demos]');
    if (!host) return null;
    var image = host.getAttribute('data-bundle-player-image');
    if (!image) return null;
    return {
      image: image,
      productUrl: host.getAttribute('data-bundle-player-url') || ''
    };
  }

  function init() {
    var root = document.getElementById(PLAYER_ID);
    var audio = document.getElementById(AUDIO_ID);
    if (!root || !audio) return;

    var artEl = root.querySelector('[data-ug-audio-art]');
    var artLink = root.querySelector('[data-ug-audio-art-link]');
    var titleLink = root.querySelector('[data-ug-audio-title-link]');
    var curEl = root.querySelector('[data-ug-audio-current]');
    var durEl = root.querySelector('[data-ug-audio-duration]');
    var progress = root.querySelector('[data-ug-audio-progress]');
    var progressWrap =
      (progress && progress.closest('.ug-audio-player__progress-wrap')) ||
      root.querySelector('.ug-audio-player__progress-wrap');
    var progressFill = root.querySelector('[data-ug-audio-progress-fill]');
    var progressThumb = root.querySelector('[data-ug-audio-progress-thumb]');
    var seekInput = root.querySelector('[data-ug-audio-seek]');
    var btnPrev = root.querySelector('[data-ug-audio-prev]');
    var btnNext = root.querySelector('[data-ug-audio-next]');
    var btnToggle = root.querySelector('[data-ug-audio-toggle]');
    var playGlyph = root.querySelector('[data-ug-audio-play-glyph]');
    var btnCollapse = root.querySelector('[data-ug-audio-collapse]');
    var btnMute = root.querySelector('[data-ug-audio-mute]');
    var volumeRange = root.querySelector('[data-ug-audio-volume]');
    var volumeWrap = root.querySelector('[data-ug-audio-volume-wrap]');
    var btnAtc = root.querySelector('[data-ug-audio-atc]');
    var atcTextEl = root.querySelector('[data-ug-audio-atc-text]');

    var playlist = [];
    var index = 0;
    var seeking = false;
    var open = false;
    var volumeBeforeMute = 1;
    var productCache = {};
    var atcBusy = false;
    var atcResetTimer = null;

    var atcLabelDefault = root.getAttribute('data-ug-atc-label') || 'Add to cart';
    var atcLabelLoading = root.getAttribute('data-ug-atc-loading') || 'Adding…';
    var atcLabelDone = root.getAttribute('data-ug-atc-done') || 'Added';
    var atcLabelGoToCart = root.getAttribute('data-ug-atc-go-to-cart') || 'Go To Cart';
    var atcLabelSoldOut = root.getAttribute('data-ug-atc-sold-out') || 'Sold out';
    var atcGoToCartMode = false;
    var ugCartUrl =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart'
        : '/cart';

    if (window.UG_ATC_LABELS) {
      atcLabelDefault = window.UG_ATC_LABELS.add || atcLabelDefault;
      atcLabelGoToCart = window.UG_ATC_LABELS.goToCart || atcLabelGoToCart;
    }

    var currentAtc = {
      variantId: '',
      productId: null,
      available: false,
      productUrl: ''
    };

    function readStoredVolume() {
      var raw = localStorage.getItem(VOLUME_STORAGE_KEY);
      if (raw === null) return 1;
      var v = parseFloat(raw, 10);
      if (!isFinite(v)) return 1;
      return Math.max(0, Math.min(1, v));
    }

    function persistVolume(v) {
      try {
        localStorage.setItem(VOLUME_STORAGE_KEY, String(v));
      } catch (e) {
        /* ignore quota / private mode */
      }
    }

    function syncVolumeUi() {
      if (!volumeRange || !btnMute) return;
      var v = audio.volume;
      var pct = Math.round(v * 100);
      volumeRange.value = String(pct);
      var muted = v <= 0.001;
      volumeWrap.classList.toggle('is-muted', muted);
      btnMute.setAttribute('aria-pressed', muted ? 'true' : 'false');
      var muteLabel = root.getAttribute(muted ? 'data-ug-unmute-aria' : 'data-ug-mute-aria');
      if (muteLabel) btnMute.setAttribute('aria-label', muteLabel);
    }

    function applyVolume(v) {
      v = Math.max(0, Math.min(1, v));
      audio.volume = v;
      if (v > 0.001) volumeBeforeMute = v;
      persistVolume(v);
      syncVolumeUi();
    }

    applyVolume(readStoredVolume());

    var mobileChatMq = window.matchMedia('(max-width: 767px)');

    function syncMobileChatLift() {
      if (!open || !mobileChatMq.matches) {
        document.body.style.removeProperty('--ug-chat-lift');
        return;
      }
      var lift = Math.ceil(root.getBoundingClientRect().height) + 8;
      document.body.style.setProperty('--ug-chat-lift', lift + 'px');
    }

    function setOpen(isOpen) {
      open = isOpen;
      document.body.classList.toggle('ug-audio-player-open', isOpen);
      root.classList.toggle('is-active', isOpen);
      root.hidden = !isOpen;
      root.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if (isOpen) {
        requestAnimationFrame(syncMobileChatLift);
      } else {
        syncMobileChatLift();
      }
    }

    window.addEventListener('resize', syncMobileChatLift);
    if (typeof mobileChatMq.addEventListener === 'function') {
      mobileChatMq.addEventListener('change', syncMobileChatLift);
    } else if (typeof mobileChatMq.addListener === 'function') {
      mobileChatMq.addListener(syncMobileChatLift);
    }

    function setPlayGlyph(isPlaying) {
      if (!playGlyph) return;
      playGlyph.classList.toggle('is-pause', isPlaying);
    }

    function syncPlayTriggersUi() {
      document.querySelectorAll('.ug-audio-play-trigger.isPlaying').forEach(function (b) {
        b.classList.remove('isPlaying');
      });
      if (!open || audio.paused || !playlist.length) return;
      if (playlist[index]) {
        playlist[index].classList.add('isPlaying');
      }
      var bundleHero = getBundleHeroBtnForPlaylist(playlist);
      if (bundleHero) {
        bundleHero.classList.add('isPlaying');
      }
    }

    function isActivePlayTrigger(btn) {
      if (!open || !playlist.length) return false;
      if (playlist[index] === btn) return true;
      var bundleHero = getBundleHeroBtnForPlaylist(playlist);
      return bundleHero === btn;
    }

    function seekToTrackStart() {
      if (!audio.src) return;
      audio.currentTime = 0;
      syncProgressFromAudio();
    }

    function setAtcLabel(text) {
      if (atcTextEl) atcTextEl.textContent = text;
    }

    function setAtcGoToCartMode(on) {
      atcGoToCartMode = !!on;
      if (!btnAtc) return;
      btnAtc.classList.toggle('is-go-to-cart', on);
      btnAtc.classList.toggle('is-added', on);
      if (on) {
        setAtcLabel(atcLabelGoToCart);
        btnAtc.setAttribute('aria-label', atcLabelGoToCart);
      }
    }

    function syncAtcButton() {
      if (!btnAtc) return;
      var hasProduct = !!(currentAtc.productUrl && currentAtc.productUrl !== '#');
      var show = open && hasProduct;
      btnAtc.hidden = !show;
      if (!show) return;

      btnAtc.classList.remove('is-loading');
      if (atcBusy) return;

      // While the playing track's product is still being fetched, never show
      // "Sold out" (the pre-fetch default would otherwise read as unavailable,
      // which is wrong — every product on this store is purchasable). If the
      // track already carries a variant id (from the markup), keep Add-to-Cart
      // enabled so there's no greyed flash; otherwise show a neutral disabled
      // state until the fetch resolves a variant.
      if (currentAtc.resolving) {
        atcGoToCartMode = false;
        btnAtc.classList.remove('is-added', 'is-go-to-cart');
        if (currentAtc.variantId) {
          btnAtc.disabled = false;
          setAtcLabel(atcLabelDefault);
          btnAtc.setAttribute(
            'aria-label',
            atcLabelDefault +
              (readTrack(playlist[index]).title ? ': ' + readTrack(playlist[index]).title : '')
          );
        } else {
          btnAtc.disabled = true;
          setAtcLabel(atcLabelDefault);
        }
        return;
      }

      if (
        currentAtc.available &&
        currentAtc.variantId &&
        typeof window.ugIsVariantInCart === 'function' &&
        window.ugIsVariantInCart(currentAtc.variantId)
      ) {
        btnAtc.disabled = false;
        setAtcGoToCartMode(true);
        return;
      }

      if (atcGoToCartMode && currentAtc.available && currentAtc.variantId) {
        btnAtc.disabled = false;
        setAtcGoToCartMode(true);
        return;
      }

      atcGoToCartMode = false;
      btnAtc.classList.remove('is-added', 'is-go-to-cart');

      if (currentAtc.available && currentAtc.variantId) {
        btnAtc.disabled = false;
        setAtcLabel(atcLabelDefault);
        btnAtc.setAttribute('aria-label', atcLabelDefault + (readTrack(playlist[index]).title ? ': ' + readTrack(playlist[index]).title : ''));
      } else if (hasProduct && !currentAtc.variantId) {
        btnAtc.disabled = true;
        setAtcLabel(atcLabelLoading);
      } else {
        btnAtc.disabled = true;
        setAtcLabel(atcLabelSoldOut);
        btnAtc.setAttribute('aria-label', atcLabelSoldOut);
      }
    }

    function pickVariant(product) {
      if (!product || !product.variants || !product.variants.length) return null;
      var i;
      for (i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) return product.variants[i];
      }
      return product.variants[0];
    }

    function fetchProductByUrl(productUrl) {
      var handle = handleFromProductUrl(productUrl);
      if (!handle) return Promise.resolve(null);
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
      })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (product) productCache[handle] = product;
          return product;
        })
        .catch(function () {
          return null;
        });
    }

    function resolveAtcForTrack(track) {
      currentAtc = {
        variantId: track.variantId || '',
        productId: null,
        available: false,
        productUrl: track.productUrl || '',
        resolving: true
      };
      syncAtcButton();

      if (currentAtc.variantId) {
        fetchProductByUrl(track.productUrl).then(function (product) {
          var variant = null;
          if (product) {
            currentAtc.productId = product.id;
          }
          if (product && product.variants) {
            var vid = String(currentAtc.variantId);
            variant = product.variants.find(function (v) {
              return String(v.id) === vid;
            });
            if (!variant) {
              variant = pickVariant(product);
              if (variant) currentAtc.variantId = String(variant.id);
            }
          }
          // Every product on this store is digital and purchasable indefinitely
          // (the main product Add-to-Cart never blocks on stock either), so a
          // resolvable variant id is enough — don't gate on the variant's stock
          // `available` flag, which can be a misleading "Sold out".
          currentAtc.available = !!(variant || currentAtc.variantId);
          currentAtc.resolving = false;
          syncAtcButton();
        });
        return;
      }

      fetchProductByUrl(track.productUrl).then(function (product) {
        if (product) {
          currentAtc.productId = product.id;
        }
        var variant = pickVariant(product);
        if (variant) {
          currentAtc.variantId = String(variant.id);
          currentAtc.available = true;
          var activeBtn = playlist[index];
          if (activeBtn && activeBtn.isConnected) {
            activeBtn.setAttribute('data-ug-audio-variant-id', currentAtc.variantId);
          }
        }
        currentAtc.resolving = false;
        syncAtcButton();
      });
    }

    function showCartFeedback(lineItem) {
      if (typeof window.recentCartItemPopUp === 'function') {
        window.recentCartItemPopUp(lineItem);
        return;
      }
      if (!window.jQuery || !lineItem) return;
      var $ = window.jQuery;
      $.getJSON('/cart.js', function (cart) {
        if (!cart) return;
        $('.cart-link .number').html(cart.item_count);
        $('.cart-link .number-wrapper').removeClass('hide');
        $('.recently-added .items-count .number').html(cart.item_count);
      });
    }

    function addCurrentTrackToCart() {
      if (atcBusy || !currentAtc.variantId || !currentAtc.available) return;
      if (
        typeof window.ugConfirmIfPurchasedDuplicate === 'function' &&
        !window.ugConfirmIfPurchasedDuplicate(currentAtc.variantId, currentAtc.productId)
      ) {
        return;
      }
      atcBusy = true;
      btnAtc.classList.add('is-loading');
      setAtcLabel(atcLabelLoading);
      btnAtc.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: Number(currentAtc.variantId), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function (lineItem) {
          btnAtc.classList.remove('is-loading');
          showCartFeedback(lineItem);
          if (typeof window.ugNoteCartLineAdded === 'function') {
            window.ugNoteCartLineAdded(lineItem);
          }
          setAtcGoToCartMode(true);
          if (typeof window.ugSyncAtcFromCart === 'function') {
            window.ugSyncAtcFromCart();
          } else if (typeof window.ugSetAtcGoMode === 'function') {
            window.ugSetAtcGoMode(true);
          }
        })
        .catch(function () {
          setAtcLabel(atcLabelDefault);
        })
        .finally(function () {
          atcBusy = false;
          syncAtcButton();
        });
    }

    function loadIndex(i) {
      if (!playlist.length) return;
      atcGoToCartMode = false;
      if (atcResetTimer) {
        clearTimeout(atcResetTimer);
        atcResetTimer = null;
      }
      index = (i + playlist.length) % playlist.length;
      var trackBtn = playlist[index];
      var track = readTrack(trackBtn);
      var bundleDisplay = getBundle3PlayerDisplay(trackBtn);
      var artImage = bundleDisplay && bundleDisplay.image ? bundleDisplay.image : track.image;
      var linkUrl =
        bundleDisplay && bundleDisplay.productUrl
          ? bundleDisplay.productUrl
          : track.productUrl;

      artEl.alt = track.title || '';
      if (artImage) {
        artEl.src = artImage;
        artEl.style.opacity = '1';
      } else {
        artEl.removeAttribute('src');
        artEl.style.opacity = '0.35';
      }
      titleLink.textContent = track.title || '';
      titleLink.href = linkUrl || '#';

      if (artLink) {
        var pUrl = linkUrl || '';
        var hasProductUrl = !!pUrl && pUrl !== '#';
        artLink.href = hasProductUrl ? pUrl : '#';
        artLink.classList.toggle('ug-audio-player__art-link--inactive', !hasProductUrl);
        artLink.tabIndex = hasProductUrl ? 0 : -1;
        var ariaBase =
          root.getAttribute('data-ug-view-product-aria') || 'Open product page';
        artLink.setAttribute(
          'aria-label',
          track.title ? ariaBase + ': ' + track.title : ariaBase
        );
      }

      var hadSrc = !!track.src;
      audio.pause();
      audio.removeAttribute('src');
      if (hadSrc) {
        audio.src = track.src;
        audio.load();
      }
      seekInput.disabled = !hadSrc;
      progress.setAttribute('aria-disabled', hadSrc ? 'false' : 'true');
      if (!hadSrc) {
        curEl.textContent = '0:00';
        durEl.textContent = '—:—';
        progressFill.style.transform = 'scaleX(0)';
        progressThumb.style.left = '0%';
        seekInput.value = 0;
        progress.setAttribute('aria-valuenow', '0');
      }
      syncPlayTriggersUi();
      resolveAtcForTrack(track);
    }

    function syncProgressFromAudio() {
      if (seeking) return;
      if (isFinite(audio.duration) && audio.duration > 0) {
        var pct = (audio.currentTime / audio.duration) * 100;
        seekInput.value = String(pct);
        progressFill.style.transform = 'scaleX(' + pct / 100 + ')';
        progressThumb.style.left = pct + '%';
        progress.setAttribute('aria-valuenow', String(Math.round(pct)));
        durEl.textContent = formatTime(audio.duration);
      } else {
        progressFill.style.transform = 'scaleX(0)';
        progressThumb.style.left = '0%';
        durEl.textContent = '—:—';
      }
      curEl.textContent = formatTime(audio.currentTime || 0);
    }

    function seekToPercent(pct) {
      pct = Math.max(0, Math.min(100, pct));
      if (!audio.duration || !isFinite(audio.duration)) return;
      audio.currentTime = (pct / 100) * audio.duration;
      syncProgressFromAudio();
    }

    audio.addEventListener('timeupdate', syncProgressFromAudio);
    audio.addEventListener('loadedmetadata', syncProgressFromAudio);
    audio.addEventListener('ended', function () {
      if (playlist.length > 1) {
        loadIndex(index + 1);
        if (readTrack(playlist[index]).src) {
          audio.play().catch(function () {});
        }
      } else {
        setPlayGlyph(false);
        syncPlayTriggersUi();
      }
    });
    audio.addEventListener('play', function () {
      setPlayGlyph(true);
      syncPlayTriggersUi();
    });
    audio.addEventListener('pause', function () {
      setPlayGlyph(false);
      syncPlayTriggersUi();
    });

    function progressFromClientX(clientX) {
      var rect = progress.getBoundingClientRect();
      if (!rect.width) return 0;
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function previewSeek(pct) {
      pct = Math.max(0, Math.min(100, pct));
      seekInput.value = String(pct);
      progressFill.style.transform = 'scaleX(' + pct / 100 + ')';
      progressThumb.style.left = pct + '%';
      progress.setAttribute('aria-valuenow', String(Math.round(pct)));
      curEl.textContent = audio.duration
        ? formatTime((pct / 100) * audio.duration)
        : '0:00';
    }

    if (window.PointerEvent && progressWrap) {
      // Unified mouse/touch/pen seeking. Pointer events give us tap-to-seek
      // and drag-to-seek on mobile, which native range inputs do not.
      var pointerSeeking = false;

      // The transparent range input would otherwise swallow taps; let the bar
      // own all pointer interaction, and stop touch-drags from scrolling.
      seekInput.style.pointerEvents = 'none';
      progressWrap.style.touchAction = 'none';

      var onProgressPointerDown = function (e) {
        if (seekInput.disabled) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        pointerSeeking = true;
        seeking = true;
        try {
          progressWrap.setPointerCapture(e.pointerId);
        } catch (err) {}
        e.preventDefault();
        previewSeek(progressFromClientX(e.clientX));
      };

      var onProgressPointerMove = function (e) {
        if (!pointerSeeking) return;
        e.preventDefault();
        previewSeek(progressFromClientX(e.clientX));
      };

      var onProgressPointerUp = function (e) {
        if (!pointerSeeking) return;
        pointerSeeking = false;
        seeking = false;
        try {
          progressWrap.releasePointerCapture(e.pointerId);
        } catch (err) {}
        seekToPercent(progressFromClientX(e.clientX));
      };

      progressWrap.addEventListener('pointerdown', onProgressPointerDown);
      progressWrap.addEventListener('pointermove', onProgressPointerMove);
      progressWrap.addEventListener('pointerup', onProgressPointerUp);
      progressWrap.addEventListener('pointercancel', onProgressPointerUp);
    } else {
      // Legacy fallback: native range input + click-to-seek on the bar.
      seekInput.addEventListener('input', function () {
        seeking = true;
        previewSeek(parseFloat(seekInput.value, 10) || 0);
      });
      seekInput.addEventListener('change', function () {
        seeking = false;
        seekToPercent(parseFloat(seekInput.value, 10) || 0);
      });
      progress.addEventListener('click', function (e) {
        if (seekInput.disabled) return;
        seekToPercent(progressFromClientX(e.clientX));
      });
    }

    var keyStep = 2;
    progress.addEventListener('keydown', function (e) {
      if (seekInput.disabled) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
        e.preventDefault();
        seekToPercent(parseFloat(seekInput.value, 10) + keyStep);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
        e.preventDefault();
        seekToPercent(parseFloat(seekInput.value, 10) - keyStep);
      }
    });

    btnToggle.addEventListener('click', function () {
      if (!open) return;
      var src = readTrack(playlist[index]).src;
      if (!src) return;
      if (audio.paused) {
        audio.play().catch(function () {});
      } else {
        audio.pause();
      }
    });

    btnPrev.addEventListener('click', function () {
      if (!open || !playlist.length) return;
      var wasPlaying = !audio.paused;
      var hasPrevMulti = playlist.length > 1 && index > 0;
      if (hasPrevMulti) {
        loadIndex(index - 1);
      } else {
        seekToTrackStart();
      }
      var t = readTrack(playlist[index]);
      if (wasPlaying && t.src) audio.play().catch(function () {});
    });

    btnNext.addEventListener('click', function () {
      if (!open || !playlist.length) return;
      var wasPlaying = !audio.paused;
      var hasNextMulti = playlist.length > 1 && index < playlist.length - 1;
      if (hasNextMulti) {
        loadIndex(index + 1);
      } else {
        seekToTrackStart();
      }
      var t = readTrack(playlist[index]);
      if (wasPlaying && t.src) audio.play().catch(function () {});
    });

    btnCollapse.addEventListener('click', function () {
      audio.pause();
      document.querySelectorAll('.ug-audio-play-trigger.isPlaying').forEach(function (b) {
        b.classList.remove('isPlaying');
      });
      setOpen(false);
    });

    if (volumeRange) {
      volumeRange.addEventListener('input', function () {
        applyVolume(parseFloat(volumeRange.value, 10) / 100);
      });
    }

    if (btnMute) {
      btnMute.addEventListener('click', function () {
        if (audio.volume > 0.001) {
          applyVolume(0);
        } else {
          applyVolume(volumeBeforeMute > 0.001 ? volumeBeforeMute : 1);
        }
      });
    }

    document.addEventListener('ug:cart-state-updated', function () {
      syncAtcButton();
    });

    if (btnAtc) {
      btnAtc.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (atcGoToCartMode) {
          window.location.href = ugCartUrl;
          return;
        }
        addCurrentTrackToCart();
      });
    }

    function playFromButton(btn) {
      if (isActivePlayTrigger(btn)) {
        if (!audio.paused) {
          audio.pause();
          return;
        }
        var resume = readTrack(btn);
        if (resume.src) {
          audio.play().catch(function () {});
        }
        return;
      }

      playlist = parsePlaylistFromButton(btn);
      if (!playlist.length) return;

      var idx = playlist.indexOf(btn);
      if (idx < 0) idx = 0;

      setOpen(true);
      loadIndex(idx);

      var track = readTrack(playlist[index]);
      if (track.src) {
        audio.play().catch(function () {});
      } else {
        setPlayGlyph(false);
      }
    }

    window.ugAudioPlayerPlayFromButton = playFromButton;

    document.body.addEventListener('click', function (e) {
      if (e.target.closest('[data-ug-audio-atc]')) return;
      var btn = e.target.closest('.ug-audio-play-trigger');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      playFromButton(btn);
    });

    document.addEventListener('visibilitychange', function () {
      /* optional: pause on tab hide — Spotify keeps playing; skip */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
